import { SelectorOption } from "../../../shared/components/filtering/filter.interfaces";
import { Page } from "../../shared/domain/models/page";

export class GetPublicationTypeOptionsByIdsInteractor {
  public async execute(ids: string[]): Promise<Page<SelectorOption>> {
    return Promise.resolve(
      new Page(
        1,
        ids.length,
        ids.length,
        ids.map((id) => ({ id: id, name: `publicationTemplate.name.${id}` })),
      ),
    );
  }
}
